import { render, staticRenderFns } from "./Multidomen.vue?vue&type=template&id=54c319e7&scoped=true&"
import script from "./Multidomen.vue?vue&type=script&lang=js&"
export * from "./Multidomen.vue?vue&type=script&lang=js&"
import style0 from "./Multidomen.vue?vue&type=style&index=0&id=54c319e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c319e7",
  null
  
)

export default component.exports